var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-project-block container text-uppercase my-3" },
    [
      _c("h4", [_vm._v("Brand Project")]),
      _vm._v(" "),
      _c("h6", { staticClass: "create-project-header" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$resourceString["myProject.createProject.modal.title"]) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wf-modal-button-close btn button-full",
          attrs: { type: "button" },
          on: {
            click: function() {
              _vm.hideModal("create-brand-project")
              _vm.handleCroppedImgData()
            }
          }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
            attrs: { "aria-label": "Close modal" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "my-3" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 col-sm-12" }, [
            _c(
              "label",
              { staticClass: "label-size-12", attrs: { for: "project_name" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString["myProject.Project.Project.Title"]
                    ) +
                    "*\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.projectData.title,
                    expression: "projectData.title",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control form-control-sm",
                attrs: {
                  type: "text",
                  id: "project_name",
                  placeholder:
                    _vm.$resourceString[
                      "myProject.Project.CreateModal.ProjectName.Placeholder"
                    ]
                },
                domProps: { value: _vm.projectData.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.projectData,
                      "title",
                      $event.target.value.trim()
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-sm-12" }, [
            _c(
              "label",
              { staticClass: "label-size-12", attrs: { for: "project_type" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.CreateModal.ProjectType.Label"
                      ]
                    ) +
                    "\n          "
                ),
                _c("span", { staticClass: "optional-field ml-3" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$resourceString[
                          "contentWizard.Label.Field.Optional"
                        ]
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "mb-2 d-flex justify-content-between align-items-center"
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.projectData.projectType,
                          expression: "projectData.projectType"
                        }
                      ],
                      staticClass: "form-control form-control-sm",
                      attrs: { name: "projectType", id: "project_type" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.projectData,
                            "projectType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "" }, domProps: { selected: true } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$resourceString[
                                  "myProject.Project.CreateModal.ProjectType.Placeholder"
                                ]
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.getProjectType.projectTypes, function(
                        typeOption
                      ) {
                        return _c(
                          "option",
                          {
                            key: typeOption.typeId,
                            domProps: { value: typeOption.typeName }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(typeOption.typeName) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "position-relative" }, [
          _c(
            "label",
            { staticClass: "label-size-12", attrs: { for: "project_cover" } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$resourceString[
                      "myProject.Project.CreateModal.ProjectCover.Label"
                    ]
                  ) +
                  "\n        "
              ),
              _c("span", { staticClass: "optional-field ml-3" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString["contentWizard.Label.Field.Optional"]
                    ) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "label-size-12 border-0 modal-content",
              attrs: { for: "tray-cover-input" }
            },
            [
              _c("div", { staticClass: "tray-cover position-relative" }, [
                _c("input", {
                  ref: "fileInput",
                  attrs: {
                    id: "tray-cover-input",
                    type: "file",
                    accept: "image/x-png,image/png,image/jpeg,image/jpg"
                  },
                  on: { change: _vm.handleFileUpload }
                }),
                _vm._v(" "),
                !_vm.selectedFileUrl ||
                (_vm.getIsstartOverOrCancel &&
                  !(_vm.trayId && !_vm.getselectAnotherImage)) ||
                (_vm.selectedFileUrl &&
                  _vm.getIsstartOverOrCancel &&
                  _vm.trayId &&
                  !_vm.getselectAnotherImage &&
                  _vm.selectedFileUrlForEdit == null)
                  ? _c("span", { staticClass: "btn btn-outline-primary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "virtualtray.Savetray.UploadImage.Button"
                            ]
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                ((_vm.trayId &&
                  !_vm.getselectAnotherImage &&
                  (!_vm.getIsstartOverOrCancel ||
                    _vm.selectedFileUrlForEdit)) ||
                  !_vm.getIsstartOverOrCancel) &&
                _vm.selectedFileUrl
                  ? _c("img", {
                      staticClass: "h-100 w-100",
                      attrs: { src: _vm.getCropeedImg, alt: "Uploaded Image" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedFileUrl && _vm.getCropeedImg
                  ? _c("div", { staticClass: "on-hover-background-card" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-outline-white-warn btn btn-outline-primary",
                          attrs: { rel: "noopener" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString[
                                "virtualtray.Savetray.UploadAnotherImage.Button"
                              ]
                            )
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _vm.trayImageUploadError
            ? _c("p", { staticClass: "text-danger label-size-12" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.CreateModal.ProjectCover.Error"
                      ]
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 col-sm-12" }, [
            _c(
              "label",
              {
                staticClass: "label-size-12",
                attrs: { for: "project-description" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.CreateModal.ProjectDetails.Label"
                      ]
                    ) +
                    "\n          "
                ),
                _c("span", { staticClass: "optional-field ml-3" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$resourceString[
                          "contentWizard.Label.Field.Optional"
                        ]
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group mb-2" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.projectData.description,
                    expression: "projectData.description"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "project-description",
                  "aria-label": "With textarea",
                  placeholder:
                    _vm.$resourceString[
                      "myProject.Project.CreateModal.ProjectDetails.Placeholder"
                    ]
                },
                domProps: { value: _vm.projectData.description },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.projectData,
                      "description",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.isTextAreaTooLong
              ? _c("p", { staticClass: "text-danger label-size-12" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.CreateModal.ProjectDetails.Error"
                        ]
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-2" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-primary",
                on: { click: _vm.handleModalClose }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                    ) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  disabled: _vm.getDisabled() || this.saveProjectDisabled
                },
                on: { click: _vm.saveProject }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.isEdit
                        ? _vm.$resourceString[
                            "myProject.Project.CreateModal.SaveProject.Button"
                          ]
                        : _vm.$resourceString[
                            "myProject.Project.CreateModal.CreateProject.Button"
                          ]
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }